__webpack_require__.p = "/restaurant_pos/";